import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isLogin: false,
    navigaterIndex: 0,
    navigaterLevel2Index: 0, //普通导航
    navigaterLevel2Id: null,
    userPersonSatus: true,
    isMedia: false,
    mediaType: null,
    myIndex: 0,
    setleftNav: 0,
    num: 0,
    userInfo: {
      id: null,
      phone: null,
      token: null,
      role: null,
      status: null,
      remark: null
    },
    articalId: null,
    artType: null,
    postId: null,
    PostType:null
  },
  mutations: {
    publicNum(state, data) {
      state.num = data.num;
      localStorage.setItem('num', data.num);
    },
    init(state) {
      var userPersonSatus = localStorage.getItem('userPersonSatus');
      if (userPersonSatus) {
        if (userPersonSatus == 'false') {
          state.userPersonSatus = false;
        }
      }
      state.num = localStorage.getItem('num');
      state.articalId = localStorage.getItem('articalId');
      state.postId = localStorage.getItem('postId');
    },
    arcId(state, data){
      state.articalId = data.data;
      localStorage.setItem('articalId', data.data);
    },
    postpubId(state, data){
      state.postId = data.data;
      localStorage.setItem('postId', data.data);
    },
    changeLoginType(state, data) {
      state.isLogin = data.data;
      localStorage.setItem('role', data.role);
    },
    setUserInfo(state, data) {
      state.userInfo = Object.assign({}, state.userInfo, data);
      localStorage.setItem('id', data.id)
      localStorage.setItem('token', data.token);
      localStorage.setItem('phone', data.phone);
      localStorage.setItem('role', data.role);
      localStorage.setItem('status', data.status);
      localStorage.setItem('remark', data.remark);
    },
	setBindPhone(state,phone){
		state.userInfo.phone = phone;
		localStorage.setItem('phone', phone);
	},
    initLoginStatus(state) {
      if (localStorage.getItem('token')) {
        state.userInfo.id = localStorage.getItem('id');
        state.userInfo.token = localStorage.getItem('token');
        state.userInfo.phone = localStorage.getItem('phone');
        state.userInfo.role = localStorage.getItem('role');
        state.userInfo.status = localStorage.getItem('status');
        state.userInfo.remark = localStorage.getItem('remark');
      }
    },
    userPerson(state, data) {
      state.userPersonSatus = data.a;
      localStorage.setItem('userPersonSatus', data.a);
    },
    choicePersonal(state, data) {
      state.isMedia = data.as;
    },
    leftNav(state, data) {
      state.navigaterIndex = data.index;
    },
    mediaStatus(state, data) {
      state.mediaType = data.type;
    },
    //审核状态编辑
    setNavindex(state, data) {
      state.setleftNav = data.ind;
      localStorage.setItem('setleftNav', data.ind);
    },
    getNavindex(state) {
      state.setleftNav = localStorage.getItem('setleftNav')
    },
    setIndexId(state, data) {
      state.navigaterLevel2Index = data.index;
      state.navigaterLevel2Id = data.id;
      localStorage.setItem('navigaterLevel2Id', data.id);
    },
    getIndexId(state) {
      state.navigaterLevel2Id = localStorage.getItem('navigaterLevel2Id');
    },


  }
});
